const actions = {
  SET_STATE: 'rewardTemplates/SET_STATE',
  FETCH_ALL_REWARD_TEMPLATES: 'rewardTemplates/FETCH_ALL_REWARD_TEMPLATES',
  FETCH_REWARD_TEMPLATE: 'rewardTemplates/FETCH_REWARD_TEMPLATE',
  EDIT_REWARD_TEMPLATE: 'rewardTemplates/EDIT_REWARD_TEMPLATE',
}

export default actions
